import { Navigate } from 'react-router-dom';

export const BillingRedirectRoute = () => {
  const returnPath = window.localStorage.getItem('returnPath') || '/settings';
  const paramSymbol = returnPath.includes('?') ? '&' : '?';

  return <Navigate to={`${returnPath}${paramSymbol}fromBilling=true`} replace />;
};
